// Kept per user (keyed by Supabase user id) so a shared phone still asks each new trial user once.
const CONFIRMED_KEY_PREFIX = 'trial_phone_notice_confirmed_at:'

const confirmedKey = (userId: string) => `${CONFIRMED_KEY_PREFIX}${userId}`

export const loadPhoneNoticeConfirmedAt = (userId: string): string | null => {
  try {
    return window.localStorage.getItem(confirmedKey(userId))
  } catch {
    return null
  }
}

export const persistPhoneNoticeConfirmedAt = (userId: string, at: string) => {
  try {
    window.localStorage.setItem(confirmedKey(userId), at)
  } catch {
    // Private mode or disabled storage: the notice asks again next visit.
  }
}
